import { useAtom } from "jotai";
import React from "react";
import { merchantAtom } from "../store";
import { isImage } from "../utils";

// interface NavbarProps {}
const Navbar = () => {
  const [merchant] = useAtom(merchantAtom);

  return (
    <div className="nav-container">
    <nav className="contain-expand">
      {merchant?.logo && (
        <div className="logo">
          {isImage(merchant?.logo) && <img src={merchant?.logo} alt="logo" />}
          {!isImage(merchant?.logo) && <p>{merchant?.companyName[0]}</p>}
        </div>
      )}

      <div className="business-name">{merchant?.companyName}</div>

      <div className="nav-button-box">

      </div>

    </nav>
    </div>
  );
};

export default Navbar;
